<template>
  <div>
    <v-card flat width="300px" class="pa-2">
      <v-text-field
        v-model="search"
        dense
        outlined
        placeholder="Buscar proveedor..."
        append-icon="mdi-magnify"
        @input="onSearch"
      ></v-text-field>

      <v-list dense>
        <v-list-item
          v-for="proveedor in proveedoresFiltered"
          :key="proveedor.id"
          link
          @click="selectProveedor(proveedor)"
        >
          <v-list-item-title>{{ proveedor.nombre }}</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="nextPage && !loading" link @click="loadMore">
          <v-list-item-content>
            <v-list-item-title class="blue--text">
              Cargar más
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="loading">
          <v-list-item-content class="text-center">
            <v-progress-circular indeterminate color="blue"></v-progress-circular>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!loading && proveedoresFiltered.length === 0">
          <v-list-item-content>
            <v-list-item-title>No hay proveedores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ProveedorListLoadMore",
  props: {
    pageSize: { type: Number, default: 8 },
  },
  data() {
    return {
      proveedores: [],
      search: "",
      nextPage: 1,
      loading: false,
    };
  },
  computed: {
    proveedoresFiltered() {
      if (!this.search) return this.proveedores;
      const q = this.search.toLowerCase();
      return this.proveedores.filter((p) =>
        p.nombre.toLowerCase().includes(q)
      );
    },
  },
  methods: {
    selectProveedor(proveedor) {
      this.$emit("set_proveedor", proveedor);
    },

    async loadMore() {
      if (!this.nextPage) return;
      this.loading = true;

      try {
        const params = new URLSearchParams();
        params.append("page", this.nextPage);
        params.append("page_size", this.pageSize);

        if (this.search) params.append("search", this.search);

        const res = await this.axios.get(`/proveedores/?${params.toString()}`);

        const existentes = new Set(this.proveedores.map((p) => p.id));
        const nuevos = res.data.results.filter((p) => !existentes.has(p.id));
        this.proveedores.push(...nuevos);

        if (res.data.next) {
          const url = new URL(res.data.next);
          this.nextPage = url.searchParams.get("page");
        } else {
          this.nextPage = null;
        }
      } catch (e) {
        console.error("Error cargando proveedores:", e);
      } finally {
        this.loading = false;
      }
    },

    onSearch() {
      this.proveedores = [];
      this.nextPage = 1;
      this.loadMore();
    },
  },

  created() {
    this.loadMore();
  },
};
</script>

<style scoped>
.v-list-item {
  cursor: pointer;
}
</style>
